import { render } from "./LangButton.vue?vue&type=template&id=e87b66a8&scoped=true"
import script from "./LangButton.vue?vue&type=script&lang=js"
export * from "./LangButton.vue?vue&type=script&lang=js"

import "./LangButton.vue?vue&type=style&index=0&id=e87b66a8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e87b66a8"

export default script